import { render, staticRenderFns } from "./componentesproteccion.vue?vue&type=template&id=2e41403e"
import script from "./componentesproteccion.vue?vue&type=script&lang=js"
export * from "./componentesproteccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports